// extracted by mini-css-extract-plugin
export default {"container":"NotEmpty_container__Z9GZQ","formContainer":"NotEmpty_formContainer__Jp3Tl","card":"NotEmpty_card__FNQ5w"};